function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import utils from "@/js/utils";
export var ReportManagementModel = /*#__PURE__*/_createClass(function ReportManagementModel() {
  _classCallCheck(this, ReportManagementModel);
  _defineProperty(this, "modal_name", 'MODAL_REPORT');
  _defineProperty(this, "selects", {
    file_type: Array()
  });
  _defineProperty(this, "buttons", {
    show_filter: false,
    show_filter_edit_variable: false
  });
  _defineProperty(this, "filter", {});
  _defineProperty(this, "grid", {
    headers: function headers(i18n, is_admin) {
      var list = [{
        text: utils.traductor(i18n, 'report_management.report_management_page.grid.columns.title'),
        value: 'title',
        align: 'center'
      }, {
        text: utils.traductor(i18n, 'report_management.report_management_page.grid.columns.type'),
        value: 'type',
        align: 'center'
      }, {
        text: utils.traductor(i18n, 'report_management.report_management_page.grid.columns.description'),
        value: 'description',
        align: 'center'
      }, {
        text: utils.traductor(i18n, 'report_management.report_management_page.grid.columns.created_date'),
        value: 'created_date',
        align: 'center'
      }, {
        text: utils.traductor(i18n, 'report_management.report_management_page.grid.columns.updated_date'),
        value: 'updated_date',
        align: 'center'
      }];
      if (is_admin) {
        list.push({
          text: utils.traductor(i18n, 'report_management.report_management_page.grid.columns.view'),
          value: 'view',
          align: 'left',
          sortable: false
        });
        list.push({
          text: utils.traductor(i18n, 'report_management.report_management_page.grid.columns.actions'),
          value: 'acciones',
          align: 'left',
          sortable: false
        });
      } else {
        list.push({
          text: utils.traductor(i18n, 'report_management.report_management_page.grid.columns.actions'),
          value: 'view',
          align: 'left',
          sortable: false
        });
      }
      return list;
    },
    data: [],
    key: 1,
    pagination: {
      current: 1,
      total: 0,
      limit: 10
    }
  });
  _defineProperty(this, "modal_report_confirmation_delete", {
    name: 'MODAL_REPORT_CONFIRM_DELETE'
  });
});